export class CreateAccountDialogConfigOptions {
    body?: string;
    title?: string;
    navigateTo: string;

    constructor(options: CreateAccountDialogConfigOptions) {
        this.body = options.body || '';
        this.title = options.title || '';
        this.navigateTo = options.navigateTo || '';
    }
}
